import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { NEVER, Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { RememberService } from "../remember/remember.service";

@Injectable()
export class AuthService implements HttpInterceptor {
  constructor(private rememberService: RememberService) {}

  public intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error && error.status === 401 && this.isApiUrl(error.url)) {
          // Allows us to decide if to show an alert to indicate that this user
          // was denied access to a specific project.
          this.rememberService.set("alerts.unauthorizedUrl", error.url);

          this.reauth();

          return NEVER;
        } else {
          return throwError(error);
        }
      }),
    );
  }

  public logout() {
    // Forget some preferences, such as alerts, because we want those to
    // re-appear occasionally.
    this.rememberService.forget("alerts.");

    this.locationReplace("/logout");
  }

  // provide our own wrapper function to make it easily mocked in specs
  public locationReplace(url: string) {
    window.location.replace(url);
  }

  private reauth() {
    // /login is a Rails route that will recreate the auth token and redirect
    // us back to NG if there is a Rails user signed in. If there isn't, it
    // will show the login form.
    this.locationReplace("/login");
  }

  private isApiUrl(url: string) {
    return url.indexOf("/api/") > -1;
  }
}
